import {BaseComponent} from '../abstract/base.component';
import { Directive } from "@angular/core";

@Directive()
export abstract class UserRoleAction extends BaseComponent {
}
